module.exports = __webpack_public_path__ + "static/img/bg-en.38433a1c.png";